<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="cocktailPro">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Cocktails professionnels
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#6b5161;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                       <h2 class="display-5 bottomH2">Formule très souple, le cocktail peut être classique, original ou innovant, selon vos impératifs d’image ou de budget.
                                       </h2>
                                        <p>
                                            Voici quelques-unes de nos propositions :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Réductions salées ou sucrées, froides ou chaudes
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                        Verrines et cuillères gourmandes
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Quiches, tartelettes et pâtés lorrains
                                            </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Sushis et makis
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Animations culinaires, etc.
                                        </li>
                                        </ul>
                                        </p>
                                        <p>
                                            De plus en plus de professionnels privilégient des compositions conviviales sous forme de grazing tables. Vos convives piochent à leur guise parmi de savoureuses bouchées piquées de brochettes… comme autour d’une table de pique-nique !
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/cocktail-entreprise/plateau-service.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Notre offre cocktail entreprise</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/cocktail-entreprise.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le COCKTAIL DÉJEUNATOIRE </span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/aperitif-entreprise.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir l'APÉRITIF ENTREPRISE</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background:#eb526e;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <p>
                                        Croustillance propose différentes options, pour répondre à tous vos besoins :
                                    </p>
                                    <p class="pAlpha">
                                    <ul>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Livraison ou enlèvement simple de vos cocktails
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Location de vaisselle, de nappes et de mange-debout
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Fourniture de boissons, avec ou sans alcool
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Mise à disposition de serveurs, etc.
                                        </li>
                                    </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail-entreprise/Cocktail-entreprise.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail-entreprise/Cocktail-entreprise.jpg" alt="Cocktail pour entreprise en Lorraine"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail-entreprise/Cocktail-entreprise.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-color:#804f4a">
                        <div class="item media text-white alignLeft">

                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Une parenthèse au travail</h3>
                                    <p>
                                        Inaugurations, temps forts de votre entreprise, anniversaires : nos cocktails d’entreprise raviront employés et invités.
                                    </p><br><br>
                                    <h3 class="display-6">
                                        Une prestation à choix multiples</h3>
                                    <p>
                                        Selon vos besoins, Croustillance peut aussi fournir la vaisselle, les boissons et/ou le personnel nécessaires à votre événement.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail-entreprise/grazin-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail-entreprise/grazin-table.jpg" alt="grazing table"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail-entreprise/grazin-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"  style="background:#502139;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Testez nos <i>grazing tables</i></h3>
                                    <p>
                                        Traduisez « tables en pâturage » ! Un concept importé des pays anglo-saxons où cohabitent joliment toutes sortes de mets à dévorer.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail-entreprise/legumes-cocktail.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail-entreprise/legumes-cocktail.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail-entreprise/legumes-cocktail.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'cocktailPro',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = " Croustillance propose aux professionnels des formules de cocktails souples et originales pour vos inaugurations, anniversaires, fêtes du personnel, etc.";
            document.title = " Cocktails pour entreprises et sociétés | Traiteur Croustillancee";
        }
    }
</script>

<style>
    #cocktailPro {
        background: url('/img/cocktail-entreprise/cocktail-traiteur.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>